/* eslint-disable max-len */
// Copyright (c) 2020 Deere & Company

import DuplicatePINPlateSearchCollections, { getDefaultState } from '../state/duplicatePINPlateSearchCollections';
import actions from '../../../../sharedmodules/actions-list';

const getPinPlateData = (state, action) => DuplicatePINPlateSearchCollections.update(state, {
    $set: action.data.length > 0 ? action.data : getDefaultState(),
});

const resetPinPlateData = (state) => DuplicatePINPlateSearchCollections.update(state, {
    $set: getDefaultState(),
});

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_PIN_PLATE_REQUEST_DATA]: getPinPlateData,
        [actions.RESET_PIN_PLATE_REQUEST_DATA]: resetPinPlateData,
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};
